import { createContext } from 'react';
import { IHostProps } from '@wix/yoshi-flow-editor';

export const HostContext = createContext<IHostProps>({} as IHostProps);
